import { makeStyles } from '@material-ui/core/styles';
const drawerWidth = 283;

const styles = theme => ({
    root: {
        flexGrow: 1,
        height: '100%',
        zIndex: 1,
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        width: '100%',
    },
    appBar: {
        position: 'absolute',
        marginLeft: drawerWidth,
        [theme.breakpoints.up('md')]: {
            width: `calc(100% - ${drawerWidth}px)`,
        },
    },
    navIconHide: {
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    toolbar: {
        ...theme.mixins.toolbar,
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        // flexDirection: 'column'
    },
    logo: {
        height: 48
    },
    drawerDocked: {
        height: '100%'
    },
    drawerPaper: {
        width: drawerWidth,
        [theme.breakpoints.up('md')]: {
            position: 'relative',
        },
    },
    content: {
        flexGrow: 1,
        overflow: 'scroll',
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing( 3 ),
    },
});

export default makeStyles(styles);